<template>
  <div class="app-main">
    <div class="content-tool">
      <div>
        <div class="content-tool--nav"  style="width: 30%;">
          <div class="content-tool--title fl">公司</div>
          <el-select v-model="providerId" filterable>
            <el-option v-for="p in providers" :key="p.providerId" :label="p.providerName" :value="p.providerId"></el-option>
          </el-select>
        </div>
        <div class="content-tool--nav">
          <div class="content-tool--title fl">姓名</div>
          <el-input placeholder="请输入姓名" icon="search" v-model.trim="uname" @keyup.enter.native="searchPayDetail" class="content-tool--input fl"></el-input>
        </div>
        <div class="content-tool--nav" style="width: 25%;">
          <div class="content-tool--title fl" style="width: 80px;">身份证号</div>
          <el-input placeholder="请输入身份证号" icon="search" v-model.trim="cardid" @keyup.enter.native="searchPayDetail" class="content-tool--input fl" style="width: calc(100% - 90px);"></el-input>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <div class="content-tool--nav" style="width: 30%;">
          <div class="content-tool--title fl" style="width: 80px;">转账状态</div>
          <el-select v-model="payStatus" placeholder="请选择">
            <el-option v-for="item in payStatusValues" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="content-tool--nav" style="width: 45%;">
          <div class="content-tool--title fl">发放时间</div>
          <el-date-picker v-model="times" type="daterange" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" align="right" :clearable="false"></el-date-picker>
        </div>
      </div>
      <div class="content-tool--operate">
        <el-button @click="searchPayDetail">查询</el-button>
        <el-button class="content-tool--reset el-button-reset" @click="reset">重置</el-button>
        <el-button type="primary" class="content-tool--qry el-button-reset" @click="downloadExcel">下载明细</el-button>
        <el-upload class="content-tool--reset el-button-reset" style="margin-left: 15px; display: inline-block;" action="" accept=".pdf" :show-file-list="false" :http-request="uploadExcel">
          <el-button type="primary">上传银行对账单</el-button>
        </el-upload>
      </div>
    </div>
    <div class="content-search-title" style="overflow: hidden; border-bottom: 1px solid #ebeef5; margin: 0 30px 20px 30px;">
      <div class="content-table--title fl" style="line-height: 55px;">
        <span style="font-size: 18px; font-weight: bold;">详情记录</span>&nbsp;总共转账
        <span class="record-num">{{ params.totalNum }}</span>
         笔，成功
        <span class="record-num">{{ params.sucNum }}</span>&nbsp;笔，失败 <span class="record-num">{{ params.failNum }}</span>&nbsp;笔
      </div>
    </div>
    <div class="content-table">
      <el-table :data="paydetails" size='medium' row-click="fetchRowDetail" tooltip-effect="dark">
        <el-table-column prop="id" label="序号" align="center" width="80px"></el-table-column>
        <el-table-column prop="uname" label="姓名" width="100px"></el-table-column>
        <el-table-column prop="uprovider" label="公司" align="left" width="200px"></el-table-column>
        <el-table-column prop="payStatus" label="状态" align="center" width="80px" :formatter="formatterStatusData"></el-table-column>
        <el-table-column prop="umoney" label="税前金额" align="center" width="100px"></el-table-column>
        <el-table-column prop="finalPayAmount" label="实发金额" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalTax" label="所得税" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalInfo" label="所得税详情" align="center" width="150px" v-if="isPersonalTax == 1"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="ucardid" label="身份证号" width="180px"></el-table-column>
        <el-table-column prop="uphone" label="手机号" width="120px"></el-table-column>
        <el-table-column prop="ubank" label="开户银行" width="160px"></el-table-column>
        <el-table-column prop="ubankcard" label="银行卡号" width="200px"></el-table-column>
        <el-table-column prop="umonth" label="发放月份" align="center"></el-table-column>
        <el-table-column prop="payTime" label="发放时间" align="center" width="160px">
          <template slot-scope="scope">
            <span>{{scope.row.payTime | parseCreateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对账单查看" align="center">
          <template slot-scope="scope">
            <div class="detail-name" @click="bankFileDownload(scope.row)" v-if="scope.row.bankAccountFile != null">查看</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="转账备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tranId" label="失败原因" align="center" width="200px" :formatter="formatterReasonData" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import { Loading } from 'element-ui';
import { parseTime } from '@/utils';

export default {
  name: 'paydetail',
  data() {
    return {
      paydetails: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      uname: '',
      providerId: '',
      cardid: '',
      params: {
        opId: '',
        totalNum: 0,
        sucNum: 0,
        failNum: 0,
      },
      providers: [],
      times: [],
      payStatus: 4,
      isPersonalTax: false,
      payStatusValues: [{
        value: 4,
        label: '全部',
      }, {
        value: 0,
        label: '正在处理',
      }, {
        value: 1,
        label: '成功',
      }, {
        value: 2,
        label: '失败',
      }, {
        value: 3,
        label: '取消转账',
      }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          },
        }],
      },
    };
  },
  filters: {
    parseCreateTime(time) {
      if (!time) {
        return '';
      }
      return parseTime(new Date(time));
    },
  },
  mounted() {
    const date = new Date();
    this.times = [date - (3600 * 1000 * 24 * 7), date.getTime()];
    this.fetchPayDetail();
    this.fetchPayDetailCount();
    this.fetchProviders();
  },
  methods: {
    formatterStatusData(data) {
      if (data.payStatus === 0) {
        return '正在处理';
      } else if (data.payStatus === 1) {
        return '成功';
      }
      return '失败';
    },
    uploadExcel(param) {
      const eleLoading = Loading.service({
        lock: true,
        text: '文件正在上传中...',
        spinner: 'el-icon-loading',
        background: '(0,0%,100%,.9)',
      });
      // 现代浏览器导入
      const fileObj = param.file;
      console.log(fileObj);
      const formData = new FormData();
      const fileTypeReg = /\.(pdf)$/gi;
      formData.append('files', fileObj);

      // 校验满足条件的文件
      if (!fileTypeReg.test(fileObj.name)) {
        eleLoading.close();
        this.$message.error('请选择 pdf 文件上传');
        return;
      }
      if (fileObj.length > 1) {
        eleLoading.close();
        this.$message.error('最多上传一个文件');
        return;
      }

      const params = {
        data: formData,
      };
      api.uploadBankFile({ params }).then((result) => {
        eleLoading.close();
        console.log('result', result);
        this.$message({
          message: '上传成功',
          type: 'success',
        });
      }).catch(() => {
        eleLoading.close();
        this.$message({
          message: '导入失败，请稍后重试',
          type: 'error',
        });
      });
    },
    formatterReasonData(data) {
      if (data.payStatus === 0) {
        return '-';
      } else if (data.payStatus === 1) {
        return '-';
      }
      return data.tranId;
    },
    searchPayDetail() {
      this.currentPage = 1;
      this.fetchPayDetail();
    },
    fetchPayDetail() {
      const params = {
        uname: this.uname,
        cardid: this.cardid,
        providerId: this.providerId,
        payStatus: this.payStatus,
        index: this.currentPage - 1,
        size: this.pageSize,
      };
      if (this.times && this.times.length === 2) {
        params.beginTime = new Date(this.times[0]).getTime();
        params.endTime = new Date(this.times[1]).getTime();
      }
      console.log(params);
      api.fetchPayDetail({
        params: {
          params,
        },
      }).then((res) => {
        this.paydetails = res.data;
        this.total = res.count;
        this.isPersonalTax = res.isPersonalTax;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    fetchPayDetailCount() {
      api.fetchPayDetailCount({
        params: {
          params: {
            uname: this.uname,
            uprovider: this.uprovider,
            uphone: this.uphone,
            payStatus: this.payStatus,
            // opId: this.params.opId,
          },
        },
      }).then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.params.totalNum = res.totalNum;
        this.params.sucNum = res.sucNum;
        this.params.failNum = res.failNum;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchPayDetail();
    },
    reset() {
      this.uname = '';
      this.providerId = null;
      this.uphone = '';
      this.payStatus = 3;
      this.times = [];
    },
    downloadExcel() {
      let beginTime = '';
      let endTime = '';
      if (this.times && this.times.length === 2) {
        beginTime = new Date(this.times[0]).getTime();
        endTime = new Date(this.times[1]).getTime();
      }
      // eslint-disable-next-line
      window.location = `/paywages/api/pay/detail/download?uname=` + this.uname + `&cardid=` + this.cardid
                    + '&providerId=' + this.providerId + '&payStatus=' + this.payStatus
                    + '&beginTime=' + beginTime + '&endTime=' + endTime;
    },
    bankFileDownload(row) {
      // eslint-disable-next-line
      window.location = row.bankAccountFile;
    },
    fetchProviders() {
      api.fetchProviders().then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.providers = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 100%;
  }
}

.content-tool {
  padding: 27px 17px 20px 17px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  // margin: 20px 20px 0px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 20%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
  padding: 30px 17px 10px 17px;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 0px 20px 0px 20px;
}
.content-search-title {
  padding: 20px 0 0 0;
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 15px;
    letter-spacing: 2px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    .record-num {
      color: #20a0ff;
    }
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
  .color-bule {
    color: #0779bd;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  margin: 30px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/components/paydetail.vue